export const appConfig = {
	apiUrl: ''
};
